var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartData.length > 0)?_c('highcharts',{ref:"pie",attrs:{"options":_vm.chartOptions}}):_c('div',[_c('span',[_vm._v(_vm._s(_vm.noData))])])}
var staticRenderFns = []
export { render, staticRenderFns }